import React, { lazy } from "react";
import { Base_Url } from "../../utils/apiUrl";

const TradedStock = lazy(() => import("../../pages/Warrant/TradedStock"));
const TradedWarrant = lazy(() => import("../../pages/Warrant/TradedWarrant"));
const TurnOverDistribution = lazy(() => import("../../pages/Warrant/TurnOverDistribution"));
const MoneyFlow = lazy(() => import("../../pages/Warrant/MoneyFlow"));
const MoneyFlowChart = lazy(() => import("../../pages/Warrant/MoneyFlowChart"));
const MarketTurnOver = lazy(() => import("../../pages/Warrant/MarketTurnOver"));
const IndexFuturesRollover = lazy(() => import("../../pages/WarrantEducation/IndexFuturesRollover"));
const Seminar = lazy(() => import("../../pages/WarrantEducation/Seminar"));
const GainExposure = lazy(() => import("../../pages/WarrantEducation/GainExposure"));
const FrequentlyAskedQues = lazy(() => import("../../pages/WarrantEducation/FrequentlyAskedQues"));
const HowToStart = lazy(() => import("../../pages/WarrantEducation/HowToStart"));
const YourFirstStep = lazy(() => import("../../pages/WarrantEducation/YourFirstStep"));
const SuccessSpeak = lazy(() => import("../../pages/WarrantEducation/SuccessSpeak"));
const WarrantGuestSpeakerVideo = lazy(() => import("../../pages/WarrantEducation/WarrantGuestSpeakerVideo"));
const WhyMacquarie = lazy(() => import("../../pages/WarrantEducation/WhyMacquarie"));
const HowUseLiveMatrix = lazy(() => import("../../pages/WarrantEducation/HowUseLiveMatrix"));
const IndexWarrant = lazy(() => import("../../pages/WarrantEducation/IndexWarrant"));
const WingrabVouchers = lazy(() => import("../../pages/WarrantEducation/WingrabVouchers"));
const HkUnderlyings = lazy(() => import("../../pages/WarrantEducation/HkUnderlying"));
const StockWarrantPage = lazy(() => import("../../pages/WarrantEducation/stockWarrantPage"));

const warrantEducationRoutes = [
  {
    path: "/education/Stockwarrants",
    element: <StockWarrantPage />,
    title: "Top traded stocks | Malaysia Warrants | Macquarie",
    description: "View the most active under1ying shares and the corresponding structured warrant with the highest liquidity.",
    keyword: "top traded stocks, top traded volume, liquidity",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  // Warrant Statistics
  {
    path: "/marketdata/toptradedstocks",
    element: <TradedStock />,
    title: "Top traded stocks | Malaysia Warrants | Macquarie",
    description: "View the most active under1ying shares and the corresponding structured warrant with the highest liquidity.",
    keyword: "top traded stocks, top traded volume, liquidity",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketdata/toptradedwarrants",
    element: <TradedWarrant />,
    title: "Top traded and top movers | Malaysia Warrants | Macquarie",
    description: "View all top traded and most active index and single stock structured warrants with highest traded volume for the day.",
    keyword: "top traded warrants, top traded volume, active warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketdata/turnoverdist",
    element: <TurnOverDistribution />,
    title: "Turnover distribution | Malaysia Warrants | Macquarie",
    description: "Learn more about today's warrant turnover distribution for top traded Malaysia underlyings.",
    keyword: "warrant turnover, turnover distribution, top traded underlyings",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketdata/moneyflow",
    element: <MoneyFlow />,
    title: "Money flow | Malaysia Warrants | Macquarie",
    description: "See which structured warrants other investors are buying and selling. Gain access to exclusive information available weekly.",
    keyword: "money flow, malaysia warrants, structured warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketdata/moneyflowchart",
    element: <MoneyFlowChart />,
    title: "Money flow | Malaysia Warrants | Macquarie",
    description: "See which structured warrants other investors are buying and selling. Gain access to exclusive information available weekly.",
    keyword: "money flow, malaysia warrants, structured warrants",
  },
  {
    path: "/marketdata/turnover",
    element: <MarketTurnOver />,
    title: "Warrant market turnover | Malaysia Warrants | Macquarie",
    description: "Find out how active the warrants market was today compared to previous days.",
    keyword: "warrants market turnover, warrants turnover, malaysia warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/Indexfuturesrollover",
    element: <IndexFuturesRollover />,
    title: "Index futures rollover | Malaysia Warrants | Macquarie",
    description: "Find out how active the warrants market was today compared to previous days.",
    keyword: "warrants market turnover, warrants turnover, malaysia warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  // Warrant Education
  {
    path: "/education/seminar",
    element: <Seminar />,
    title: "Seminars | Malaysia Warrants | Macquarie",
    description: "Register online on our website to attend warrant seminars for FREE!",
    keyword: "call warrants, seminar, malaysia warrants",
    ogType: "website",
    ogTitle: "Macquarie",
    ogImage: `${Base_Url}/photo?seminar=&lang=en`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/warrant-education/HKunderlyings",
    element: <GainExposure />,
    title: "Gain exposure to HK market | Malaysia Warrants| Macquarie",
    description: "Learn about the Hang Seng Index, Hang Seng TECH Index and Hong Kong shares, and how to gain leveraged exposure to them with structured warrants listed on Bursa!",
    keyword: "Malaysia Warrants, Hong Kong Underlyings, Macquarie",
    ogUrl: `${Base_Url}/warrant-education/HKunderlyings`,
    ogType: "website",
    ogTitle: "Gain exposure to HK market",
    ogDescription: "Learn more about warrants over HSI, HSTECH and HK shares",
    ogImage: `${Base_Url}/img/hkunderlyings/fb_meta_image.png`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/faq",
    element: <FrequentlyAskedQues />,
    title: "FAQ | Malaysia Warrants | Macquarie",
    description: "Not familiar with warrants? Browse through the frequently asked questions and have all of your questions regarding warrants answered.",
    keyword: "call warrants, structured warrants, warrants FAQ",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/getstarted",
    element: <HowToStart />,
    title: "How to get started | Malaysia Warrants | Macquarie",
    description: "Want to get started with trading warrants but not sure how? See our step by step guide now!",
    keyword: "how to get started, where to trade warrants, Malaysia warrants",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/FirstStep",
    element: <YourFirstStep />,
    title: "Structured warrants: take your first step now",
    description: "Welcome to Macquarie Warrants. Take your first step towards learning about structured warrants now!",
    keyword: "Malaysia warrants, structured warrants, Macquarie",
    ogUrl: `${Base_Url}/FirstStep`,
    ogType: "website",
    ogTitle: "Structured Warrants: First Step",
    ogDescription: "Take your first step towards learning about structured warrants now!",
    ogImage: `${Base_Url}/img/landing/ogMetaImg.jpg`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/SuccessSpeaks",
    element: <SuccessSpeak />,
    title: "Malaysia Warrants | Success Speaks | Macquarie",
    description: "What does it take to be a warrant trader? Introducing Joey, Jason and TK, who have generously agreed to be interviewed and to share their secrets with you!",
    keyword: "Malaysia Warrants, Success Speaks, Macquarie",
    ogUrl: `${Base_Url}/SuccessSpeaks`,
    ogType: "website",
    ogTitle: "Success Speaks",
    ogDescription: "What does it take to be a warrant trader?",
    ogImage: `${Base_Url}/img/education/fbogmeta.png`,
  },
  {
    path: "/education/warrantvideos",
    element: <WarrantGuestSpeakerVideo />,
    title: "Warrant videos | Malaysia Warrants | Macquarie",
    description: "Watch our animated series and our guest speaker videos to improve your knowledge in structured warrants now!",
    keyword: "warrant video, structured warrants, Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/whymacquarie",
    element: <WhyMacquarie />,
    title: "Why Macquarie? | Malaysia Warrants | Macquarie",
    description: "Macquarie is the leading warrants issuer in Asia with the largest market share in Singapore and Malaysia. Learn more about our business strengths here.",
    keyword: "structured warrants, malaysia warrants, Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/warrantvideosind",
    element: <HowUseLiveMatrix />,
    title: "Warrant videos",
    ogType: "website",
    ogTitle: "Episode 5: How to use the Live Matrix for real time warrant prices  (3:17)",
    ogDescription: "Macquarie's Live Matrix shows you where Macquarie warrant's bid and offer prices will be, in real time!",
    ogImage: "https://i.ytimg.com/vi/y7Zkk7yuoDs/hqdefault.jpg",
  },
  {
    path: "/education/warrantvideosind/:title/:id/:index",
    element: <HowUseLiveMatrix />,
    title: "Warrant videos",
    ogType: "website",
    ogTitle: "Episode 5: How to use the Live Matrix for real time warrant prices  (3:17)",
    ogDescription: "Macquarie's Live Matrix shows you where Macquarie warrant's bid and offer prices will be, in real time!",
    ogImage: "https://i.ytimg.com/vi/y7Zkk7yuoDs/hqdefault.jpg",
  },
  {
    path: "/education/indexwarrants/:underlying",
    element: <IndexWarrant />,
    title: "Index/ETF warrants | Malaysia Warrants | Macquarie",
    description: "Learn more about Index Warrants issued by Macquarie, the first to issue warrants over the Hang Seng TECH Index on Bursa Malaysia.",
    keyword: "index warrant, HSI warrant, HSTECH warrant",
    ogUrl: `${Base_Url}/education/indexwarrants`,
    ogType: "website",
    ogTitle: "Trade index warrants ",
    ogDescription: "Check out the warrants over Hang Seng TECH Index and other index underlyings!",
    ogImage: `${Base_Url}/img/home/HSTECH_OG_Meta.png`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/indexwarrants",
    element: <IndexWarrant />,
    title: "Index/ETF warrants | Malaysia Warrants | Macquarie",
    description: "Learn more about Index Warrants issued by Macquarie, the first to issue warrants over the Hang Seng TECH Index on Bursa Malaysia.",
    keyword: "index warrant, HSI warrant, HSTECH warrant",
    ogUrl: `${Base_Url}/education/indexwarrants`,
    ogType: "website",
    ogTitle: "Trade index warrants ",
    ogDescription: "Check out the warrants over Hang Seng TECH Index and other index underlyings!",
    ogImage: `${Base_Url}/img/home/HSTECH_OG_Meta.png`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/education/wingrabvouchers",
    element: <WingrabVouchers />,
  },
  {
    path: "/HKunderlyings",
    element: <HkUnderlyings />,
    title: "Gain exposure to HK market | Malaysia Warrants| Macquarie",
    description: "Learn about the Hang Seng Index, Hang Seng TECH Index and Hong Kong shares, and how to gain leveraged exposure to them with structured warrants listed on Bursa!",
    keyword: "Malaysia Warrants, Hong Kong Underlyings, Macquarie",
    ogUrl: `${Base_Url}/warrant-education/HKunderlyings`,
    ogType: "website",
    ogTitle: "Gain exposure to HK market",
    ogDescription: "Learn more about warrants over HSI, HSTECH and HK shares",
    ogImage: `${Base_Url}/img/hkunderlyings/fb_meta_image.png`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
];

export default warrantEducationRoutes;
